import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const Layers = (param)=>{
    let { size = 24, testId, style, className } = param;
    const strokeWidth = 1.5 * (24 / size);
    return /*#__PURE__*/ _jsxs("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M9.70607 11.4617L3.56992 8.41133C2.81003 8.03358 2.81003 6.96642 3.56992 6.58867L9.70607 3.5383C11.1499 2.82057 12.8501 2.82057 14.2939 3.5383L20.4301 6.58867C21.19 6.96642 21.19 8.03358 20.4301 8.41133L14.2939 11.4617C12.8501 12.1794 11.1499 12.1794 9.70607 11.4617Z",
                stroke: "currentColor",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19.4422 11.047L20.4301 11.6113C21.19 11.9875 21.19 13.0502 20.4301 13.4263L14.2939 16.4639C12.8501 17.1787 11.1499 17.1787 9.70607 16.4639L3.56992 13.4263C2.81003 13.0502 2.81003 11.9875 3.56992 11.6113L4.64327 11",
                stroke: "currentColor",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19.4422 16.047L20.4301 16.6113C21.19 16.9875 21.19 18.0502 20.4301 18.4263L14.2939 21.4639C12.8501 22.1787 11.1499 22.1787 9.70607 21.4639L3.56992 18.4263C2.81003 18.0502 2.81003 16.9875 3.56992 16.6113L4.64327 16",
                stroke: "currentColor",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
